import { InfoTxt, ModalHeader } from '../../component/ModalRef';
import InputBox from '../../component/InputBox';
import TextAreaBox from '../../component/TextAreaBox';
import ConfirmButtonBox from '../../component/buttons/ConfirmButtonBox';
import TelNoInputBox from '../../component/TelNoInputBox';

const SmsHistoryModal = ({ type, row, callback, modalRef }) => {
    const onClickConfirm = () => {
        modalRef.current.close();
    };
    return (
        <>
            <ModalHeader title='SMS발송이력' modalRef={modalRef} />
            <div className='modal-body'>
                <div className='con-inner SmsHistoryModal'>
                    <InfoTxt infoTxt='SMS발송이력 정보를 조회합니다.' />
                    <div className='form-box-row'>
                        <InputBox title='발송일시' size='large' disabled value={row.sendDttm} maxLength='64' />
                        <InputBox title='발송유형' size='small' disabled value={row.sendTypeCd} maxLength='64' />
                        <TelNoInputBox title='수신번호' size='medium' disabled value={row.phone} maxLength='64' />
                    </div>
                    {row.title && (
                        <div className='form-box-row'>
                            <InputBox title='제목' disabled value={row.title} maxLength='64' />
                        </div>
                    )}
                    <div className='form-box-row'>
                        <TextAreaBox title='내용' value={row.msg} disabled />
                    </div>
                    <div className='form-box-row'>
                        <InputBox title='발송결과' disabled value={row.resMessage} maxLength='64' />
                        <TelNoInputBox title='발신번호' disabled value={row.callback} maxLength='64' />
                        <InputBox title='발신자ID' disabled value={row.sendUserId} maxLength='64' />
                    </div>
                </div>
                <div className='modal-btn-wrap'>
                    <ConfirmButtonBox title='확인' onClick={onClickConfirm} />
                </div>
            </div>
        </>
    );
};

export default SmsHistoryModal;
